import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import "./ToolBarLeftPanel.scss";

import expandIcon from "../../images/leftArrow.svg";
import checkMarkGreen from "../../images/CheckmarkGreen.svg";
import AssociatedCard from "./AssociatedCard";
import ValueContext from "../../utils/contextAPI/contextAPI";
import { getVeevaLinkedModulesListByid, getAllScripts } from "../../services/apis";
import {
  mainClaimHasUnusedContentOnEditor,
  componentHasUnusedContentOnEditor,
  reusableTextHasUnusedContentOnEditor,
} from "../../utils/editorUtils/claimEditorUsage";

const AssociatedModules = ({
  selectedModule,
  setSelectedModule,
  moduleClaimsData,
  sendAtomDetails2Canvas,
  customDrag,
  editor,
}) => {
  const [expandModule, setExpandModule] = useState([]);
  const [expand, setExpand] = useState([]);
  const [currentModule, setCurrentModule] = useState(0);
  const [modulesList, setModulesList] = useState(null);
  const [usedClaims, setUsedClaims] = useState(false);
  const [canvasGen, setCanvasGen] = useState(0);
  /** One array for the whole module — all claim cards must share it so related symbols stay in sync. */
  const [assignedSymbols, setAssignedSymbols] = useState(null);

  const appData = useContext(ValueContext);
  const { pageId } = useParams();
  const moduleDam = moduleClaimsData?.moduleDamName;

  // console.log(appData, "================= on moduls");
  useEffect(() => {
    const anyExpanded = expandModule.some((item) => item === true);
    setExpand(anyExpanded);
  }, [expandModule]);

  useEffect(() => {
    setExpandModule([]);
    setExpand(false);
  }, [currentModule]);

  useEffect(() => {
    setAssignedSymbols(null);
  }, [moduleDam]);

  useEffect(() => {
    if (!pageId || !moduleDam || !modulesList?.length) return;
    getAllScripts(pageId, (response, err) => {
      if (err || !response?.data?.relatedClaimsData) return;
      const rows = response.data.relatedClaimsData;
      const idsModule = new Set(modulesList.map((item) => item.module_name));
      const linked = modulesList.reduce((acc, item) => {
        const rules = item.content_module_response?.moduleBusinessRules || [];
        return acc.concat(rules.map((r) => r.targetModuleDamName));
      }, []);
      const allowed = new Set([...idsModule, ...linked]);
      const filtered = rows.filter((item) => allowed.has(item.moduleId));
      setAssignedSymbols(filtered);
    });
  }, [pageId, moduleDam, modulesList]);

  useEffect(() => {
    getModules();
  }, []);

  useEffect(() => {
    if (!editor?.on) return undefined;
    const refresh = () => setCanvasGen((g) => g + 1);
    editor.on("component:add", refresh);
    editor.on("component:remove", refresh);
    editor.on("undo", refresh);
    editor.on("redo", refresh);
    editor.on("load", refresh);
    return () => {
      editor.off?.("component:add", refresh);
      editor.off?.("component:remove", refresh);
      editor.off?.("undo", refresh);
      editor.off?.("redo", refresh);
      editor.off?.("load", refresh);
    };
  }, [editor]);

  const getModules = () => {
    // console.log('eee----', appData);
    // appData.setDeckId({ ...appData?.deckId, _id: edetailId });
    getVeevaLinkedModulesListByid(
      appData?.deckId?._id,
      (response, err, errorCode) => {
        if (err) {
        } else {
          // console.log("called modules", response.data.response.content_modules);
          setModulesList(response.data.response.content_modules);
        }
      },
    );
  };

  const filterOnEditor = (checked) => {
    setUsedClaims(checked);
  };

  const selectedModuleData = appData?.deckId?.selected_module_data;

  const showClaimRow = (claim) => {
    if (!usedClaims) return true;
    void canvasGen;
    return mainClaimHasUnusedContentOnEditor(
      editor,
      claim,
      moduleDam,
      selectedModuleData,
    );
  };

  const showReusableRow = (reusable) => {
    if (!usedClaims) return true;
    void canvasGen;
    return reusableTextHasUnusedContentOnEditor(
      editor,
      reusable,
      moduleDam,
      selectedModuleData,
    );
  };

  const showComponentRow = (compo) => {
    if (!usedClaims) return true;
    void canvasGen;
    return componentHasUnusedContentOnEditor(
      editor,
      compo,
      moduleDam,
      selectedModuleData,
    );
  };

  return (
    <>
      <div className="selected-module-window ">
        <div className="buissness-rule-div">
          <img
            src={expandIcon}
            onClick={() => setSelectedModule(undefined)}
            className="expandIcon-module"
          />
          <div style={{ paddingLeft: "7px" }} className="infoText">
            Module
          </div>
          <div style={{ paddingLeft: "4px" }}>:</div>
          <img src={checkMarkGreen} className="check-mark-green" />
          <strong className="boldText">
            {selectedModule?.module_name || selectedModule?.targetModuleDamName}
          </strong>
        </div>
        {/* <div className="editor-custom-js-toggle d-flex align-items-center " style={{padding:'0px 12px'}}>
          <label className="toggle-label">Not used in editor</label>
          <label className="toggle-switch-btn">
            <input
              type="checkbox"
              checked={usedClaims}
              name="switchToggle"
              onChange={(e) => filterOnEditor(e.target.checked)}
            />
            <span className="toggle-switch switch-round" />
          </label>
        </div> */}
        <div className="note-text mb-3 mt-1">
          {/* {expand ? "Note: All elements below are approved for use." : ""} */}
          Note: All elements below are approved for use.
        </div>
        <div className="must-use-div mb-3">
          <div
            className="parentModulebox"
            style={{ backgroundColor: "#E32B35" }}
          ></div>
          <div className="rulesText">Must use</div>
          <div
            className="parentModulebox"
            style={{ backgroundColor: "#378A05", marginLeft: "12px" }}
          ></div>
          <div className="rulesText">Optional</div>
        </div>{" "}
        <div className="switch-section-div">
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 0 ? "2px solid #203662" : "",
              color: currentModule === 0 ? "#203662" : "#54565c",
              fontWeight: currentModule === 0 ? "600" : "",
            }}
            onClick={() => setCurrentModule(0)}
          >
            {`Claims (${
              moduleClaimsData?.claims?.length > 0
                ? moduleClaimsData?.claims?.length
                : 0
            })`}
          </div>
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 1 ? "2px solid #203662" : "",
              color: currentModule === 1 ? "#203662" : "#54565c",
              fontWeight: currentModule === 1 ? "600" : "",
            }}
            onClick={() => setCurrentModule(1)}
          >
            {`Reusable Text (${
              moduleClaimsData?.reusableTexts?.length > 0
                ? moduleClaimsData?.reusableTexts?.length
                : 0
            })`}
          </div>
          <div
            className="section-change"
            style={{
              borderBottom: currentModule === 2 ? "2px solid #203662" : "",
              color: currentModule === 2 ? "#203662" : "#54565c",
              fontWeight: currentModule === 2 ? "600" : "",
            }}
            onClick={() => setCurrentModule(2)}
          >
            {`Component (${
              moduleClaimsData?.components?.length > 0
                ? moduleClaimsData?.components?.length
                : 0
            })`}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "#DDDFDD",
            height: "0.5px",
          }}
        ></div>
        <div className="mt-2 custonScrollBar modulesCliamsection">
          {currentModule === 0 && (
            <>
              {moduleClaimsData?.claims
                ?.filter((claim) => showClaimRow(claim))
                .map((claim, index) => {
                  return (
                    <AssociatedCard
                      modulesArray={moduleClaimsData?.claims}
                      claim={claim}
                      expandModule={expandModule}
                      setExpandModule={setExpandModule}
                      sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                      customDrag={customDrag}
                      index={index}
                      editor={editor}
                      moduleClaimsData={moduleClaimsData}
                      modulesList={modulesList}
                      usedClaims={usedClaims}
                      canvasGen={canvasGen}
                      assignedSymbols={assignedSymbols}
                      setAssignedSymbols={setAssignedSymbols}
                      key={`${index}_${claim.claimName}`}
                    />
                  );
                })}
            </>
          )}
          {currentModule === 1 && (
            <>
              {moduleClaimsData?.reusableTexts
                ?.filter((reusable) => showReusableRow(reusable))
                .map((reusableText, index) => {
                  return (
                    <AssociatedCard
                      modulesArray={moduleClaimsData?.reusableTexts}
                      reusableText={reusableText}
                      expandModule={expandModule}
                      setExpandModule={setExpandModule}
                      sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                      customDrag={customDrag}
                      index={index}
                      editor={editor}
                      moduleClaimsData={moduleClaimsData}
                      modulesList={modulesList}
                      usedClaims={usedClaims}
                      canvasGen={canvasGen}
                      assignedSymbols={assignedSymbols}
                      setAssignedSymbols={setAssignedSymbols}
                      key={`${index}_${reusableText.reusableTextName}`}
                    />
                  );
                })}
            </>
          )}
          {currentModule === 2 && (
            <>
              {moduleClaimsData?.components
                ?.filter((compo) => showComponentRow(compo))
                .map((component, index) => {
                  return (
                    <AssociatedCard
                      modulesArray={moduleClaimsData?.components}
                      component={component}
                      expandModule={expandModule}
                      setExpandModule={setExpandModule}
                      sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                      customDrag={customDrag}
                      index={index}
                      editor={editor}
                      moduleClaimsData={moduleClaimsData}
                      modulesList={modulesList}
                      usedClaims={usedClaims}
                      canvasGen={canvasGen}
                      assignedSymbols={assignedSymbols}
                      setAssignedSymbols={setAssignedSymbols}
                      key={`${index}_${component.componentDocNumber}`}
                    />
                  );
                })}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AssociatedModules;
